import { AutogenModelApDivisionLookup, AutogenRowApDivisionLookup } from "./autogen/AutogenModelApDivisionLookup";

export class ModelApDivisionLookup extends AutogenModelApDivisionLookup<RowApDivisionLookup> {
	constructor() {
		super(RowApDivisionLookup);
	}
}

export class RowApDivisionLookup extends AutogenRowApDivisionLookup {
}